import { render, staticRenderFns } from "./AIAssistanceButton.vue?vue&type=template&id=f734137a&scoped=true&"
import script from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistanceButton.vue?vue&type=style&index=0&id=f734137a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f734137a",
  null
  
)

export default component.exports